import { appBus } from '@/events/bus'

type JobEvent = { job_id?: string; event_type?: string; payload?: Record<string, unknown>; detail?: string }

/** Opens the V2 job stream when available. EventSource is deliberately optional
 * so static builds and test environments do not require a running API server. */
export function connectJobEvents() {
  if (typeof EventSource === 'undefined') return () => undefined
  const source = new EventSource('/api/v2/events')
  const dispatch = (raw: MessageEvent<string>) => {
    try {
      const event = JSON.parse(raw.data) as JobEvent
      const jobId = String(event.job_id ?? '')
      const type = String(event.event_type ?? raw.type ?? '').toLowerCase()
      if (type.includes('progress')) appBus.emit('job:progress', { jobId, progress: Number(event.payload?.progress ?? event.payload?.completed_units ?? 0) })
      if (type.includes('complete') || type.includes('succeed') || type.includes('fail')) appBus.emit('job:completed', { jobId, status: type.includes('fail') ? 'failed' : 'succeeded' })
    } catch { /* malformed events should not take down the application */ }
  }
  source.onmessage = dispatch
  for (const eventName of ['job.progress', 'job:progress', 'job.completed', 'job:completed', 'job.failed']) source.addEventListener(eventName, dispatch)
  return () => source.close()
}
